export const BLUE = '#003B6F'
export const YELLOW = '#FFD058'
export const SIGN_OUT_YELLOW = '#FFBF3A'
export const TEXT_INACTIVE = '#A0BBDC'
export const PAGE_BG = '#d1d9e2'
export const BREADCRUMB_GREY = '#7A8A9A'
export const DIVIDER_BLUE = 'rgba(153,188,223,0.3)'
export const HOVER_TINT = 'rgba(255,255,255,0.04)'

export const MOBILE_QUERY = '(max-width:899.95px)'

/**
 * The feelgreat theme shrinks `body1`/`body2` typography to 14px under
 * `@media (max-width:599px)`. Inline `sx={{ fontSize }}` has equal CSS
 * specificity, so a media-query override is required to keep the font size
 * stable across breakpoints. This helper bakes that override in.
 */
export const lockedFont = (fontSize: string, lineHeight?: string) => ({
    fontSize,
    ...(lineHeight ? { lineHeight } : {}),
    '@media (max-width:599px)': {
        fontSize,
        ...(lineHeight ? { lineHeight } : {})
    }
})
